import { entries, filter, isIncludedIn, } from 'remeda';
/*
 * the ordering inside of the array is important for combined roles.
 * The first one is the most important and will be used
 * TODO: probably, we should combine permissions instead of
 * priority. Alternativerly, merge leafs with the group and
 * use "yes" or "no" for the leafs
 */
export const permissionsOptions = {
    'customer.create': [
        'all',
    ],
    'customer.edit': [
        'all',
        'customer',
    ],
    // there is a dicrepancy between who can edit and who can deactivate staff members
    'staff.deactivate': [
        'all',
        'customer',
    ],
    // user.create has very extended permissions to manage the users.
    // For example, it allows change the role
    // Which user type can be created by the requester
    // TODO: instead of fix roles like `therapist` and `assistant`,
    // this should be stored in database with FK to the roles
    'user.create.admin': [
        'all',
        'customer', // unused, only to make TypeScript happy
    ],
    'user.create.customeradmin': [
        // allows creating users for any customer
        'all',
        // allows creating users only for own customers
        'customer',
    ],
    'user.create.therapist': [
        'all',
        'customer',
    ],
    'user.create.assistant': [
        'all',
        'customer',
    ],
    'user.create.therapistdrs': [
        'all',
        'customer',
    ],
    'user.edit.registered': [
        'all',
        'customer',
        'own',
    ],
    'user.edit.admin': [
        'all',
        'customer', // unused, only to make TypeScript happy
        'own', // unused, only to make TypeScript happy
    ],
    'user.edit.customeradmin': [
        'all',
        // allows edit users only for own customers
        'customer',
        'own',
    ],
    'user.edit.therapist': [
        'all',
        'customer',
        // allow edit only own profile
        'own',
    ],
    'user.edit.assistant': [
        'all',
        'customer',
        'own',
    ],
    'user.edit.therapistdrs': [
        'all',
        'customer',
        'own',
    ],
    'user.delete.admin': [
        'all',
        'customer', // unused, only to make TypeScript happy
    ],
    'user.delete.customeradmin': [
        'all',
        // allows deletion of users only for own customers
        'customer',
    ],
    'user.delete.therapist': [
        'all',
        'customer',
    ],
    'user.delete.assistant': [
        'all',
        'customer',
    ],
    'user.delete.therapistdrs': [
        'all',
        'customer',
    ],
    // allows edit billing approval setting. Doesn't require user.edit.${role} permission
    'user.edit-billing-approval': [
        'all',
        // requester is allowed to change the setting for other staff members
        'customer',
        // requester is allowed to change own setting
        'own',
    ],
    // requester can see the own profile
    'user.see.own': [
        'all',
    ],
    'user.see.client': [
        // requester can see all the clients of the same customer
        'customer',
    ],
    'user.see.specialist': [
        // requester can see all specialists
        'all',
        // requester can see all the specialists of the same customer
        'customer',
    ],
    'appointment.see': [
        // allows to see all appointments of the same customer
        'customer',
        // allows to see assigned appointments
        'specialist-own',
        // allows to see the public data of an appointment
        'public',
    ],
    // create, edit, and delete appointments
    'appointment.edit': [
        // allows to edit all appointments of the same customer
        'customer',
        // allows to edit assigned appointments
        'specialist-own',
    ],
    'appointment.bill': [
        // allows create bills for appointments. Needs 'appointment.edit'
        'allowed',
    ],
    // clients's medical fee schedules
    'medicalfeeschedule.edit': [
        // allows to see and edit all medical fee schedules of the same customer
        'customer',
        // allows to see and edit assigned medical schedules
        'specialist-own',
    ],
    // electronic patient record
    'patientrecord.edit': [
        // every therapist and assistant should see and edit
        // master data of all customer's clients
        'customer',
    ],
    'patientrecord.download': [
        'customer',
        // currently, "own" means individual clients
        'specialist-own',
    ],
    // clients's medical fee schedules
    'medicalhistory.edit': [
        // allows to see and edit assigned medical schedules
        'specialist-own',
    ],
    'videochat.join': [
        'customer',
        'specialist-own',
    ],
    // allows to create invoices and create/delete overdue notices
    'invoice.create': [
        'customer',
        'specialist-own',
    ],
    // allows to see, download, cancel, and mark invoices as paid
    // allows to see and download invoice overdue notices
    'invoice.manage': [
        'customer',
        'specialist-own',
    ],
    // allows to delete invoices. Needs 'invoice.manage'
    'invoice.delete': [
        'customer',
        'specialist-own',
    ],
    // administrative tasks
    'appointmenttype.edit': [
        'customer',
        'specialist-own',
    ],
    'mollie.onboarding': [
        'customer',
    ],
};
export function hasAnyPermission(permissions, ...check) {
    return filter(check, isIncludedIn(permissions)).length > 0;
}
export const allPermissions = entries(permissionsOptions).flatMap(([permission, scopes]) => scopes.map(scope => `${permission}.${scope}`));
//# sourceMappingURL=Permission.js.map